export const ACKNOWLEDGED_SPOTLIGHT_ITEMS_KEY = 'acknowledgedSpotlightItems';
